import request from "./../utils/request";

export function getAllWorkFlows() {
    return request({
        url: "/tasks/workflows",
        method: "get",
    });
}

export function getWorkflowPipelines(workflowId) {
    return request({
        url: `/tasks/workflows/${workflowId}/pipelines`,
        method: "get",
    });
}

export function getTasks(workflowId, pipelineId, assignees, page = 1, perPage = 15) {
    return request({
        url: workflowId && pipelineId ? `/tasks/${workflowId}/${pipelineId}` : `/tasks/${workflowId}`,
        method: "get",
        params: {
            assignees,
            page,
            perPage,
        },
    });
}

export function updateTaskPosition(taskId, payload) {
    return request({
        url: `/tasks/${taskId}/position`,
        method: "patch",
        data: payload,
    });
}

export function updatePipelinePosition(workflowId, pipelineId, position) {
    return request({
        url: `/tasks/${workflowId}/${pipelineId}/position`,
        method: "patch",
        data: { position },
    });
}

export function createTask(payload) {
    return request({
        url: `/tasks`,
        method: "post",
        data: payload,
    });
}

export function createSimpleTask(payload) {
    return request({
        url: `/tasks/simple`,
        method: "post",
        data: payload,
    });
}

export function deleteTask(taskId) {
    return request({
        url: `/tasks/${taskId}`,
        method: "delete",
    });
}

export function createWorkflow(payload) {
    return request({
        url: `/tasks/workflows`,
        method: "post",
        data: payload,
    });
}

export function updateWorkflow(id, payload) {
    return request({
        url: `/tasks/workflows/${id}`,
        method: "patch",
        data: payload,
    });
}

export function getTaskDetail(taskId) {
    return request({
        url: `/tasks/${taskId}/detail`,
        method: "get",
    });
}

export function updateTask(taskId, payload) {
    return request({
        url: `/tasks/${taskId}`,
        method: "patch",
        data: payload,
    });
}

export function attachmentsDelete(taskId, attachmentId) {
    return request({
        url: taskId ? `/tasks/${taskId}/attachments/${attachmentId}` : `/tasks/attachments/${attachmentId}`,
        method: "delete",
    });
}

export function createPipelineStage(workflowId, payload) {
    return request({
        url: `/tasks/workflows/${workflowId}/pipelines`,
        method: "post",
        data: payload,
    });
}

export function updatePipelineStage(pipelineId, payload) {
    return request({
        url: `/tasks/pipelines/${pipelineId}`,
        method: "patch",
        data: payload,
    });
}

export function getListTasks(assignees,page, perPage, visitorId) {
    return request({
        url: `/tasks/list`,
        method: "get",
        params: {
            assignees,
            page,
            perPage,
            visitorId,
        },
    });
}

export function deletePipelineStage(pipelineId, workflowId, newTaskPositionId) {
    return request({
        url: `/tasks/pipelines/${pipelineId}`,
        method: "delete",
        data: { workflowId, newTaskPositionId },
    });
}

export function getWorkflowDetails(workflowId) {
    return request({
        url: `/tasks/workflows/${workflowId}`,
        method: "get",
    });
}

export function multipleTaskDelete(taskIds) {
    return request({
        url: `/tasks/multiple/delete`,
        method: "post",
        data: {
            taskIds,
        },
    });
}

export function multipleTaskMove(pipelineId, taskIds) {
    return request({
        url: `/tasks/multiple/change-pipeline`,
        method: "post",
        data: {
            pipelineId,
            taskIds,
        },
    });
}

export function deleteWorkflow(workflowId) {
    return request({
        url: `/tasks/workflows/${workflowId}`,
        method: "delete",
    });
}

export function getTaskListByDate(userId, startDate, endDate) {
    return request({
        url: `/tasks/get-event-list-by-date`,
        method: "get",
        params: {
            userId,
            startDate,
            endDate,
        },
    });
}

export function doneTask(taskId) {
    return request({
        url: `/tasks/${taskId}/done`,
        method: "patch",
    });
}

export function getListDoneTask(assignees, page, perPage, visitorId) {
    return request({
        url: `/tasks/done-tasks`,
        method: "get",
        params: {
            assignees,
            page,
            perPage,
            visitorId,
        },
    });
}

export function archiveTask(taskId) {
    return request({
        url: `/tasks/${taskId}/archive`,
        method: "patch",
    });
}

export function getArchiveTask(workflowId) {
    return request({
        url: `/tasks/workflows/${workflowId}/archive-tasks`,
        method: "get",
    });
}

export function getDoneTask(workflowId) {
    return request({
        url: `/tasks/workflows/${workflowId}/done-tasks`,
        method: "get",
    });
}

export function getListArchiveTasks(siteId, assignees, page, perPage, visitorId) {
    return request({
        url: `/tasks/archive-tasks`,
        method: "get",
        params: {
            siteId,
            assignees,
            page,
            perPage,
            visitorId,
        },
    });
}

export function changeWorkflow(taskId, workflowId) {
    return request({
        url: `/tasks/${taskId}/change-workflow`,
        method: "patch",
        data: { workflowId },
    });
}
